import * as Sentry from "@sentry/browser";

export function initSentry() {
  Sentry.init({
    dsn: "https://9ab7186db129883c9169cb2aa7c55f65@o4506089149169664.ingest.us.sentry.io/4508648965341184",

    enabled: import.meta.env.PROD,

    integrations: [],

    // Define how likely traces are sampled.
    // Use tracesSampler for greater control.
    // We should lower this in production when we have more traffic.
    tracesSampleRate: 1.0,

    // Setting this option to true will print useful information to the console while you're setting up Sentry.
    debug: false,
    // Tunnel error reports through our domain to bypass ad-blockers
    // Configured in vercel.json to proxy /error-monitoring → sentry.io
    tunnel: "/error-monitoring",
  });

  window.SENTRY_CAPTURE_EXCEPTION = (error: unknown) => {
    Sentry.captureException(error);
  };

  window.SENTRY_REPORT_ISSUE = (params: {
    source?: string;
    message: string;
    context?: string;
  }) => {
    const error = new Error(params.message);
    error.name = params.source ? `${params.source}Issue` : "ReportedIssue";

    Sentry.withScope((scope) => {
      if (params.source) scope.setTag("source", params.source);
      if (params.context) scope.setExtra("context", params.context);
      Sentry.captureException(error);
    });
  };
}
